import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(auth)/login/components/LoginForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(auth)/login/components/RegisterLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DefaultHeadScripts"] */ "/app/src/app/lib/root/scripts.tsx");
